/**
 * Available Exports
 */

const ANONYMOUS_DONATIONS = 'ANONYMOUS_DONATIONS'
const DISBURSEMENTS = 'DISBURSEMENTS'
const EMPLOYEE_CODE_IMPORTS = 'EMPLOYEE_CODE_IMPORTS'
const EVENTS = 'EVENTS'
const EXPENSES = 'EXPENSES'
const MESSAGES = 'MESSAGES'
const EXTERNAL_DONATIONS = 'OFF_GRANT_CIRCLE_DONATIONS'
const PAYROLL_REQUESTS = 'PAYROLL_REQUESTS'
const SURVEY_ANSWERS = 'SURVEY_ANSWERS'
const SURVEY_RESPONSES = 'SURVEY_RESPONSES'
const USERS = 'USERS'
const USER_DONATIONS = 'USER_DONATIONS'
const USER_EVENTS = 'USER_EVENTS'
const RECURRING_DONATIONS = 'RECURRING_DONATIONS'
const ADMIN_AUDIT_TRAIL = 'ADMIN_AUDIT_TRAIL'
const ORGANIZATION_DEFAULT = 'ORGANIZATION_DEFAULT'
const STIPEND_REQUESTS = 'STIPEND_REQUESTS'
const SHEF_SUB_ORG_REPORT = 'SHEF_SUB_ORG_REPORT'
const NORTHWESTERN_ROLLING_REPORT = 'NORTHWESTERN_ROLLING_REPORT'
const UF_NOMINATIONS_REPORT = 'UF_NOMINATIONS_REPORT'
const UF_MONEY_DUE_TO_NOMINATORS_REPORT = 'UF_MONEY_DUE_TO_NOMINATORS_REPORT'
const UF_PARTICIPANTS_REPORT = 'UF_PARTICIPANTS_REPORT'
const CHF_SUB_ORG_REPORT = 'CHF_SUB_ORG_REPORT'

const SHEF_DATASETS = [{ value: SHEF_SUB_ORG_REPORT, label: 'School Heroes Sub-Org Report' }]

const CHF_DATASETS = [{ value: CHF_SUB_ORG_REPORT, label: 'Community Heroes Sub-Org Report' }]

const NORTHWESTERN_DATASETS = [
  { value: NORTHWESTERN_ROLLING_REPORT, label: 'Northwestern Rolling Report' },
]

const UF_DATASETS = [
  {
    value: UF_NOMINATIONS_REPORT,
    label: 'Nominations Report (All-Time)',
  },
  {
    value: UF_MONEY_DUE_TO_NOMINATORS_REPORT,
    label: 'Money Due to Nominators Report',
  },
  {
    value: UF_PARTICIPANTS_REPORT,
    label: 'Participants Report',
  },
]

const EXPORTABLE_DATASETS = [
  { value: ADMIN_AUDIT_TRAIL, label: 'Admin Audit Trail' },
  { value: ANONYMOUS_DONATIONS, label: 'Anonymous Donations' },
  { value: DISBURSEMENTS, label: 'Disbursements' },
  { value: EMPLOYEE_CODE_IMPORTS, label: 'Employee Code Imports' },
  { value: EVENTS, label: 'Events' },
  { value: EXPENSES, label: 'Expenses' },
  { value: MESSAGES, label: 'Messages' },
  { value: EXTERNAL_DONATIONS, label: 'Off-Grant Circle Donations' },
  { value: PAYROLL_REQUESTS, label: 'Payroll Requests' },
  { value: SURVEY_ANSWERS, label: 'Survey Answers' },
  { value: SURVEY_RESPONSES, label: 'Survey Responses' },
  { value: USERS, label: 'Users' },
  { value: USER_DONATIONS, label: 'User Donations' },
  { value: USER_EVENTS, label: 'User Events' },
  { value: RECURRING_DONATIONS, label: 'Recurring Donations' },
]

const STAFF_ONLY_DATASETS = [
  { value: ORGANIZATION_DEFAULT, label: 'Organization Configuration' },
  { value: STIPEND_REQUESTS, label: 'Stipend Requests' },
]

export default {
  ANONYMOUS_DONATIONS,
  DISBURSEMENTS,
  EMPLOYEE_CODE_IMPORTS,
  EVENTS,
  EXPENSES,
  MESSAGES,
  EXTERNAL_DONATIONS,
  PAYROLL_REQUESTS,
  SURVEY_ANSWERS,
  SURVEY_RESPONSES,
  USERS,
  USER_DONATIONS,
  USER_EVENTS,
  RECURRING_DONATIONS,
  EXPORTABLE_DATASETS,
  ADMIN_AUDIT_TRAIL,
  STAFF_ONLY_DATASETS,
  ORGANIZATION_DEFAULT,
  SHEF_SUB_ORG_REPORT,
  SHEF_DATASETS,
  NORTHWESTERN_ROLLING_REPORT,
  NORTHWESTERN_DATASETS,
  UF_NOMINATIONS_REPORT,
  UF_MONEY_DUE_TO_NOMINATORS_REPORT,
  UF_DATASETS,
  CHF_SUB_ORG_REPORT,
  CHF_DATASETS,
}
